import { State, } from '../../graphql/graphql';
import React from 'react';
import styled from 'styled-components';
import { StyledTitle } from './MetadataMessage';
import { useTranslation } from 'react-i18next';
import { TextDir } from '../../design_system/TextDir';
const AdvisorComposing = styled.div `
  display: flex;
  padding: 0 1rem;
  align-items: center;
  font-size: 0.8rem;
  gap: 0.5rem;
  position: fixed;
  width: 100%;
  bottom: 4rem;
  padding-inline-end: 1rem;
  padding-block: 0.25rem;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
`;
export const MessagingStateMessage = ({ event, }) => {
    const { t, i18n } = useTranslation();
    if (event.messagingStateEvent.state !== State.AdvisorComposing) {
        return null;
    }
    return (React.createElement(AdvisorComposing, { dir: i18n.dir() },
        React.createElement(StyledTitle, { "data-testid": "advisor-composing", variant: "mesto", semanticColor: "textSubdued", weight: "book" },
            React.createElement(TextDir, null, t('IS_TYPING_TEXT', {
                advisor_name: event.messagingStateEvent.from,
            })))));
};
